<template>
    <div class="biometrics-list">

        <b-card no-body>
            <b-card-header>
                <div class="float-right">
                    <biometrics-edit-modal :participantId="participant.id">
                    </biometrics-edit-modal>
                </div>
                <h5 class="float-left">
                    {{ $i18n.gt('HEADING_BIOMETRICS') }}
                </h5>
                <div class="float-left ml-5">
                    <b-form-checkbox switch
                                     v-model="showOlder"
                                     v-if="values.length > 0">
                        {{ $i18n.gt('LABEL_SHOW_OLDER_VALUES') }}
                    </b-form-checkbox>
                </div>
            </b-card-header>
            <table class="table table-striped">
                <template v-for="(b,i) in values">
                    <tr v-if="!!b" :key="i" >
                        <th>
                            <timestamp :date="b.updated"></timestamp>
                        </th>
                        <td>
                            {{ b.comment }}
                        </td>
                        <td>
                            <biometrics-summary :biometrics="b"
                                                :show-values="true">
                            </biometrics-summary>
                        </td>
                    </tr>
                </template>
            </table>
        </b-card>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'

/**
 * A list of Biometrics records for the current patient
 */
export default Vue.extend({
    name: 'BiometricsList',
    data() {
        return {
            showOlder: false
        }
    },
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        values() {
            const list = this.participant.latestBiometrics
            if (this.showOlder) {
                return list
            } else if (list && list.length > 0) {
                return [_.head(list)]
            } else {
                return []
            }
        }
    }
})

</script>
